export default __webpack_public_path__ + "static/media/pic4.c95590ed.jfif";